module.exports = __webpack_public_path__ + "files/d3a8b4be202bc0fc280e8f31c6b775f1.png";